// @flow

import type { ExtractReturn } from '@ta/common.types';
import type { Action as AllActions } from './state';

const NEW_API_REQUESTS = 'NEW_API_REQUESTS';
export const newApiRequests = (requests: { [string]: string }) => ({
  type: NEW_API_REQUESTS,
  requests,
});

const NEW_API_RESPONSE = 'NEW_API_RESPONSE';
export const newApiResponse = (data: { [string]: { [string]: string } }) => ({
  type: NEW_API_RESPONSE,
  data,
});

const REQUEST_API_REBIND = 'REQUEST_API_REBIND';
export const requestApiRebind = () => ({
  type: REQUEST_API_REBIND,
});

export type Action =
  | ExtractReturn<typeof newApiRequests>
  | ExtractReturn<typeof newApiResponse>
  | ExtractReturn<typeof requestApiRebind>;

type RequestId = string;
type ApiEndpoint = string;
type RequestLoadingState = {|
  loading: boolean,
  result: ApiEndpoint[],
  url: string,
|};
type ApiData<T> = {| data: ?T, error: ?string |};

export type State = {|
  requests: { [RequestId]: RequestLoadingState },
  responses: { [ApiEndpoint]: ApiData<*> },
  rebindCount?: ?number,
|};

const emptyState = () =>
  ({
    requests: {},
    responses: {},
  }: State);

export default (state: State = emptyState(), action: AllActions) => {
  switch (action.type) {
    case NEW_API_REQUESTS: {
      const newRequests = Object.keys(action.requests).reduce(
        (accum, requestId) => ({
          ...accum,
          [requestId]: {
            loading: true,
            result: [],
            url: action.requests[requestId],
          },
        }),
        {},
      );
      return { ...state, requests: { ...state.requests, ...newRequests } };
    }

    case NEW_API_RESPONSE: {
      const newRequests = Object.entries(action.data).reduce(
        (accum, [requestId, responses]) => ({
          ...accum,
          [requestId]: {
            ...state.requests[requestId],
            loading: false,
            result: Object.keys((responses: any)),
          },
        }),
        {},
      );
      const newResponses = (Object.entries(Object.assign({}, ...Object.values(action.data))): any)
        .filter(([endpoint, response]) => endpoint && response && response.status && response.body)
        .reduce(
          (accum, [endpoint, { status, body }]) => ({
            ...accum,
            [endpoint]: status === 200 ? { data: body, error: null } : { data: null, error: body },
          }),
          {},
        );
      return {
        ...state,
        requests: { ...state.requests, ...newRequests },
        responses: { ...state.responses, ...newResponses },
      };
    }

    case REQUEST_API_REBIND: {
      return {
        ...state,
        rebindCount: (state.rebindCount || 0) + 1,
      };
    }

    default:
      return state;
  }
};
